
import Vue from "vue";
import { BrowsePermissions } from "../../models/user-configs/browse-permissions";
import { UserConfigService } from "../../services/user-config-service";
import AppIcon from "@/components/common/AppIcon.vue";
export default Vue.extend({
	props: {
		to: String,
		newTo: String,
		icon: String,
		text: [Object, String],
		newLabel: Boolean,
		newLabelText: String,
		permissions: {
			type: Object as ()=>BrowsePermissions,
			required: false
		}
	},
	computed: {
		canRead():boolean{
			if (!this.permissions){
				return true;
			}
			return UserConfigService.hasCurrentUserPermission((p)=>this.permissions.CanRead && !this.permissions.BrowseHidden);
		}
	},
	methods: {
		newClicked(){
			this.$router.push(this.newTo);
		}
	},
	components: { AppIcon }
});
